import React, { Component } from "react";
import logo from "../images/logo.svg";
import "./header.css";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

class Header extends Component {
  render() {
    return (
      <div className="header">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-6 col-sm-2">
              <Link to="/experiencezone/">
                <img src={logo} alt="Logo" />
              </Link>
            </div>
            <div className="col-2 float-right">
              <a href="/" class="btn btn-warning home-btn ">
                Login
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
